import { render, staticRenderFns } from "./AcoesSolicitarReadequacao.vue?vue&type=template&id=60480eba&scoped=true"
import script from "./AcoesSolicitarReadequacao.vue?vue&type=script&lang=js"
export * from "./AcoesSolicitarReadequacao.vue?vue&type=script&lang=js"
import style0 from "./AcoesSolicitarReadequacao.vue?vue&type=style&index=0&id=60480eba&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60480eba",
  null
  
)

export default component.exports